"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from "../../utilities/props.js";
import { useTabs } from "./TabsContext.js";
import s from "./Tabs.module.css";
const TabsPanel = (props) => {
    const { value: panelValue, children, className, attributes } = props;
    const { value, panelId, buttonId } = useTabs(panelValue);
    const active = panelValue === value;
    const panelClassNames = classNames(s.panel, !active && s["--panel-hidden"], className);
    return (_jsx("div", { ...attributes, className: panelClassNames, tabIndex: 0, role: "tabpanel", id: panelId, "aria-labelledby": buttonId, children: active && children }));
};
TabsPanel.displayName = "Tabs.Panel";
export default TabsPanel;
